// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import RouterLink from "redux-first-router-link";

import * as atypes from "src/constants/actionTypes";
import ChatRoomName from "src/containers/chatroom/Name";
import useChatroom from "src/hooks/useChatroom";

import type { RoomId, UnifizeChatRoom } from "src/types";

type Props = {
  nolink: boolean,
  id: RoomId
};

const BreadCrumb = ({ id, nolink }: Props) => {
  const chatroom: UnifizeChatRoom = useChatroom(id);
  const { address = "", templateId = "" } = chatroom || {};

  if (nolink || !address) {
    return (
      <>
        <ChatRoomName id={id} noTitle={false} />
        <span>{i18n.t(k._18)}</span>
      </>
    );
  }

  return (
    <RouterLink
      key={id}
      title={id}
      to={{
        type: atypes.SET_CURRENT_CHATROOM_REQUEST,
        payload: { id: address },
        meta: {
          query: {
            templateId
          }
        }
      }}
    >
      <ChatRoomName id={id} noTitle={false} isBreadcrumb />
      <span>{i18n.t(k._18)}</span>
    </RouterLink>
  );
};

export default BreadCrumb;
